namespace GeniuzPOS.Member {
    export class MbReport02_Columns {
        static columnsKey = 'Member.MbReport02_';
    }
}
